/*
 * @Author: Yun
 * @Date: 2024-02-18 11:07:08
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-01 11:17:57
 */
import React from 'react'
import iconvideo from '@icons/iconvideo.png'
import close from '@icons/closevideo.jpg'
import $ from 'jquery'
import './index.less'

window.jwplayer.key = '44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK'

const PREFIX = 'cgtn-jwplayer'

const CgtnJwplayer = (props) => {
    const { className, id, videoUrl, cover } = props

    const onVideoPlay = () => {
        $('body').css('overflow', 'hidden')
        let dom = `${id}`
        $(`.${PREFIX}-cover`).css('display', 'block')
        window.jwplayer(dom).setup({
            file: videoUrl,
            primary: 'html5',
            width: '100%',
            stretching: 'uniform',
            allowFullscreen: 'false',
            // preload: 'auto',
            // aspectratio: '9:16',
            height: '100vh',
        })
        window.jwplayer(dom).play()
        window.jwplayer(dom).on('play', function () {
            setTimeout(() => {
                $(`.${PREFIX}-cover`).css('display', 'none')
                $(`.${PREFIX}-videoClose`).css('display', 'block')
            }, 500)
        })
    }

    const onRemovePlayer = () => {
        $('body').css('overflow', 'auto')
        window.jwplayer(`${id}`).remove()
        $(`.${PREFIX}-cover`).css('display', 'none')
        $(`.${PREFIX}-videoClose`).css('display', 'none')
    }

    return (
        <div className={`${PREFIX}`}>
            <div className={`${PREFIX}-cover`}>
                Video loading <span>...</span>
            </div>
            <img
                className={`${PREFIX}-iconvideo ${className}`}
                src={cover ? cover : iconvideo}
                alt=""
                id={id}
                onClick={onVideoPlay}
            />
            <img className={`${PREFIX}-videoClose`} src={close} alt="" onClick={onRemovePlayer} />
        </div>
    )
}

export default CgtnJwplayer
